
export const TaskHeadings1=[
    {
        name:'Name',
        value:'fullName'
    },
    {
        name:'Phone Number',
        value:'mobile'
    },
    {
        name:'Type',
        value:'type'
    },
    {
        name:'Ratings',
        value:'megacabsRating'
    },
    {
        name:'Car Number',
        value:'mainCabNo'
    },
    {
        name:'Car Type',
        value:'carType'
    }
]



export const TaskData1={
    name:'Narasimha Gupta',
    phone_number:'+91 8967498888',
    type:'Primary',
    ratings:'4.8',
    car_number:'KA-01-AB-4361',
    car_type:'MUV'
}